import { render, staticRenderFns } from "./FangYuan.vue?vue&type=template&id=6b9b184e&scoped=true"
import script from "./FangYuan.vue?vue&type=script&lang=js"
export * from "./FangYuan.vue?vue&type=script&lang=js"
import style0 from "./FangYuan.vue?vue&type=style&index=0&id=6b9b184e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9b184e",
  null
  
)

export default component.exports